export default __webpack_public_path__ + "static/media/str.9ad9e0a5.jfif";